module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAAAlwSFlzAAAOwwAADsMBx2+oZAAAABp0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjUuMTFH80I3AAAANUlEQVQ4T2NgGAV4Q6C8vPw/RUEEMgAbJtpQbC7A6SpibSPJW8QaitNLVDGA6AAbVUh+CAAAM+RFVXDkh64AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/pinned.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/pinned.png
// module chunks = styles